import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyImagesTabsQueryParamsType,
  GetBodyImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyImagesTabs/getBodyImagesTabsQuery.type';

export const getBodyImagesTabsQueryFunction = (
  params: GetBodyImagesTabsQueryParamsType,
): Promise<GetBodyImagesTabsQueryResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/images/entry_tabs/`, {
    params,
  });
};
